import { authorizedRequest, reportAnonymousLoginFailure } from '../utils/request';

const root = kind => {
    if (!['login', 'operation'].includes(kind)) throw new Error('Unknown audit category');
    return `/audit/${kind}`;
};
export const listAudit = (kind, params) => authorizedRequest('GET', root(kind), { params });
export const auditSummary = (kind, params) => authorizedRequest('GET', `${root(kind)}/summary`, { params });
export const auditOptions = (kind, params) => authorizedRequest('GET', `${root(kind)}/option`, { params });
export const auditDetail = (kind, id) => authorizedRequest('GET', `${root(kind)}/detail/${encodeURIComponent(id)}`);
export const exportAudit = (kind, params) => authorizedRequest('GET', `${root(kind)}/export`, { params });
export const reportExternalOperation = data => authorizedRequest('POST', '/audit/report', { data });
export const recordLoginSession = () => authorizedRequest('POST', '/audit/session');
export const reportLoginFailure = reportAnonymousLoginFailure;
